import React from 'react';
import { PlusCircle, Zap } from 'lucide-react';

const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  investmentFrequencies
}) => {
  if (!formData.additionalInvestments) {
    return (
      <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <PlusCircle className="w-5 h-5 mr-2 text-indigo-500" />
          Дополнительные инвестиции
        </h3>
        
        <div className="mb-2">
          <div className="flex items-start">
            <div className="flex items-center h-5">
              <input
                id="additionalInvestments"
                name="additionalInvestments"
                type="checkbox"
                checked={formData.additionalInvestments}
                onChange={handleInputChange}
                className="form-checkbox"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="additionalInvestments" className="font-medium text-gray-700 dark:text-gray-300">
                Включить регулярные дополнительные инвестиции
              </label>
              <p className="text-gray-500 dark:text-gray-400">
                Добавление фиксированной суммы к инвестиции с выбранной периодичностью
              </p>
            </div>
          </div>
          {errors.additionalInvestments && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.additionalInvestments}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PlusCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительные инвестиции
      </h3>
      
      <div className="mb-2">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              id="additionalInvestments"
              name="additionalInvestments"
              type="checkbox"
              checked={formData.additionalInvestments}
              onChange={handleInputChange}
              className="form-checkbox"
            />
          </div>
          <div className="ml-3 text-sm">
            <label htmlFor="additionalInvestments" className="font-medium text-gray-700 dark:text-gray-300">
              Включить регулярные дополнительные инвестиции
            </label>
            <p className="text-gray-500 dark:text-gray-400">
              Добавление фиксированной суммы к инвестиции с выбранной периодичностью
            </p>
          </div>
        </div>
        {errors.additionalInvestments && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.additionalInvestments}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {/* Сумма дополнительной инвестиции */}
        <div>
          <label htmlFor="additionalInvestmentAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Сумма дополнительной инвестиции
          </label>
          <div className="flex">
            <input
              type="text"
              id="additionalInvestmentAmount"
              name="additionalInvestmentAmount"
              value={formData.additionalInvestmentAmount}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.additionalInvestmentAmount ? 'input-error' : ''}`}
              placeholder="Введите сумму"
            />
          </div>
          {errors.additionalInvestmentAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.additionalInvestmentAmount}
            </p>
          )}
        </div>

        {/* Периодичность дополнительных инвестиций */}
        <div>
          <label htmlFor="additionalInvestmentFrequency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Периодичность
          </label>
          <select
            id="additionalInvestmentFrequency"
            name="additionalInvestmentFrequency"
            value={formData.additionalInvestmentFrequency}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.additionalInvestmentFrequency ? 'input-error' : ''}`}
          >
            {investmentFrequencies.map((frequency) => (
              <option key={frequency.id} value={frequency.id}>
                {frequency.name}
              </option>
            ))}
          </select>
          {errors.additionalInvestmentFrequency && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.additionalInvestmentFrequency}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
        <div className="flex items-start">
          <Zap className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Преимущество регулярных инвестиций
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Стратегия регулярного инвестирования (DCA, Dollar Cost Averaging) позволяет снизить влияние волатильности рынка 
              и улучшить среднюю цену входа в долгосрочной перспективе.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;